export function required(value) {
  return {
    valid: !!value,
    errorMessage: 'Bitte geben Sie einen Wert ein.',
  }
}
